import { TurnstileWidgetProps, Turnstile } from "./interfaces";
import { getTheme } from "../common/utils";

declare global {
  interface Window {
    onTurnstileSuccess: (token: string) => void;
    onTurnstileTimeout: (...args: any[]) => void;
    onTurnstileExpired: (...args: any[]) => void;
    onTurnstileError: (...args: any[]) => void;
    onTurnstileUnsupported: (...args: any[]) => void;
    onTurnstileBeforeInteractive: (...args: any[]) => void;
    onTurnstileAfterInteractive: (...args: any[]) => void;
    turnstile: Turnstile;
  }
}

const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({
  action = "login",
  widgetId = "cloudflare-turnstile-widget",
  size = "flexible",
  appearance = Salla.config.get("login.turnstile.displayed") ? "execute" : "interaction-only",
  className = "cf-turnstile",
}) => {
  // Set up the success callback
  window.onTurnstileSuccess = (token: string) => Salla.api.setHeader("s-render-key", token);
  window.onTurnstileTimeout = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileTimeout", { error_type: "re-captcha-v3::timeout", error_details: args });
  window.onTurnstileExpired = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileExpired", { error_type: "re-captcha-v3::expired", error_details: args });
  window.onTurnstileError = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileError", { error_type: "re-captcha-v3::error", error_details: args });
  window.onTurnstileUnsupported = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileUnsupported", { error_type: "re-captcha-v3::unsupported", error_details: args });
  window.onTurnstileBeforeInteractive = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileBeforeInteractive", { error_type: "re-captcha-v3::before-interactive", error_details: args });
  window.onTurnstileAfterInteractive = (...args: any[]) => Salla.analytics.log("Login Error::onTurnstileAfterInteractive", { error_type: "re-captcha-v3::after-interactive", error_details: args });

  // Load the script only once (using a guard)
  if (!document.querySelector("#cloudflare-turnstile-script")) {
    const script = document.createElement("script");
    script.id = "cloudflare-turnstile-script";
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  const style = appearance !== "interaction-only" ? { marginTop: "20px", marginBottom: "5px" } : {};

  return (
    <div
      id={widgetId}
      style={style}
      data-size={size}
      data-action={action}
      className={className}
      data-theme={getTheme()}
      data-callback="onTurnstileSuccess"
      data-error-callback="onTurnstileError"
      data-expired-callback="onTurnstileExpired"
      data-before-interactive-callback="onTurnstileBeforeInteractive"
      data-after-interactive-callback="onTurnstileAfterInteractive"
      data-unsupported-callback="onTurnstileUnsupported"
      data-timeout-callback="onTurnstileTimeout"
      data-appearance={appearance}
      data-feedback-enabled={false}
      data-language={Salla.lang.getLocale()}
      data-sitekey={Salla.config.get("login.turnstile.key") ?? Salla.config.get("login.turnstile_site_key")}
    ></div>
  );
};

export default TurnstileWidget;
